module.exports = __webpack_public_path__ + "img/bb_m_3_ja.053fe6b7.jpg";